/** A pdf.js preset, or a scale where 1 is 100%. */
export type ZoomMode = "auto" | "page-width" | "page-fit" | number;

export type Rotation = 0 | 90 | 180 | 270;

/** Where a viewer opens. */
export type ViewerSession = {
	page: number;
	zoom: ZoomMode;
	rotation: Rotation;
};

export const DEFAULT_SESSION: ViewerSession = {
	page: 1,
	zoom: "auto",
	rotation: 0,
};

export const toRotation = (degrees: number): Rotation => {
	const normalized = (((Math.round(degrees / 90) * 90) % 360) + 360) % 360;
	return normalized === 90 || normalized === 180 || normalized === 270 ? normalized : 0;
};
